
<v-app>
  <Lightbox :file="file" />
</v-app>
